import commonFn from '@/commons/commonFunction.js';
import { useContextStore } from '@/stores/contextStore';
import { useApplicationStore } from '@/stores/platform/applicationStore';
import EventEmitter from '@/lib/vue3-socket-io/emitter';
import accountApi from '@/apis/auth/accountApi';

class AuthService extends EventEmitter {
  /**
   * Kiểm tra xem còn session đăng nhập ko
   * xử lý đăng xuất dvc khi hết session nhhoang1 27.02.2024
   */
  isAuthenticated() {
    const contextStore = useContextStore();
    const context = contextStore.context;
    let isAuth = false;
    if (context && context.token) {
      const expired = new Date(context.tokenTimeout);
      if (expired && expired > new Date()) {
        isAuth = true;
      }
    }

    return isAuth;
  }

  /**
   * xử lý login qua misaid
   * hàm này sẽ build link ra redirect qua trang misaid để login
   */
  login(callbackUrl) {
    commonFn.mask();
    // build ra url gọi sang trang của misaid
    let state = new Date().getTime();
    if (callbackUrl) {
      state += '|' + callbackUrl;
    }

    // Xóa trước x-platform-version cho chắc
    commonFn.deleteCookie('x-platform-version');

    const redirectUrl = window._misaId.getUrl('loginUrl').replace('{state}', state);
    console.log(`Resirect URL value trong core: ${redirectUrl}`)
    location.href = redirectUrl;
  }

  /**
   * xử lý logout qua misaid
   * hàm này sẽ build link ra redirect qua trang misaid để logout
   * Updated: Xóa cache theo tenantId - 20/01/2026
   */
  async logout(callbackUrl) {
    commonFn.mask();
    // build ra url gọi sang trang của misaid
    let state = new Date().getTime();
    if (callbackUrl) {
      state += '|' + callbackUrl;
    }

    // Xóa cache khi logout
    const applicationStore = useApplicationStore();
    applicationStore.resetAllAdminSystemRole(); // Xóa tất cả cache admin role theo tenantId

    // Xóa trước x-platform-version để tránh bị lỗi khi logout
    commonFn.deleteCookie('x-platform-version');

    try {
      await accountApi.logout();
    } catch (error) {
      console.error('Error in logout:', error);
    }

    try {
      await accountApi.logoutWithoutRedirect().catch((err) => { });
    } catch (error) {
      console.error('Có lỗi xảy ra khí xóa phiên bên misa platform', error);
    }
    // Đăng xuất ngầm ioffice qua iframe (best-effort, không block redirect)
    await this._logoutIofficeByIframe();

    const redirectUrl = window._misaId.getUrl('logoutUrl').replace('{state}', state);
    location.href = redirectUrl;
  }

  /**
   * Đăng xuất ngầm ioffice bằng iframe ẩn.
   * Iframe là top-level navigation trong context của ioffice → browser gửi đầy đủ cookie ioffice.
   * X-Frame-Options chỉ block render — request vẫn đến server và logout được xử lý.
   * Best-effort: timeout 2s, không throw, không block luồng logout chính.
   */
  _logoutIofficeByIframe() {
    const iofficeLogoutUrl = window._apis?.IofficeLogout;
    if (!iofficeLogoutUrl) return Promise.resolve();

    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.src = iofficeLogoutUrl;
      iframe.style.cssText = 'display:none;position:absolute;width:0;height:0;border:none;';

      const done = () => {
        clearTimeout(timer);
        //iframe.remove();
        resolve();
      };

      const timer = setTimeout(done, 2000);
      iframe.onload = done;
      iframe.onerror = done;

      document.body.appendChild(iframe);
    });
  }
}

export default new AuthService();
